export interface Role {
    id: number;
    role_name: string
  }

  export const mapRole = (data:any): Role => {
    if(!data){
        throw new Error('Invalied Role type')
    }


    const uesrRole: Role = {
        id: data.id,
        role_name: data.role_name
    }

    return uesrRole;
}

export const mapRoles = (data: any[]): Role[] => {
    if (!Array.isArray(data)) {
      throw new Error('Invalid Role data');
    }
  
    return data.map(mapRole);
  };